import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Inventaire / stock — boîte/colis duotone */
export const InventoryIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Face supérieure menthe */}
      <path
        d="M12 3l9 4.5v0L12 12 3 7.5 12 3z"
        fill="var(--equiply-icon-bg)"
      />
      {/* Boîte 3D */}
      <path
        d="M12 3l9 4.5v9L12 21 3 16.5v-9L12 3z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Arête centrale */}
      <path
        d="M12 12v9"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
      <path
        d="M3 7.5l9 4.5 9-4.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Petite anse */}
      <path
        d="M7.5 5.25l9 4.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.25" strokeLinecap="round"
      />
    </svg>
  ),
);
InventoryIcon.displayName = "InventoryIcon";
